import * as z from "zod";
import { FieldSchema, type ManifestValidationResult, validateManifest } from "./_shared.js";

export const ConnectorManifestSchema = z.looseObject({
  name: z.string().min(1),
  description: z.string().min(1),
  version: z.string().optional(),
  entry: z.string().min(1),
  npm_deps: z
    .object({
      required: z.array(z.string()).optional(),
      optional: z.array(z.string()).optional(),
    })
    .optional(),
  fields: z.array(FieldSchema).optional(),
  health_check: z.string().nullable().optional(),
  keywords: z.array(z.string()).optional(),
  license: z.string().optional(),
});

export type ConnectorManifest = z.infer<typeof ConnectorManifestSchema>;

export function validateConnector(data: unknown): ManifestValidationResult<ConnectorManifest> {
  return validateManifest(ConnectorManifestSchema, data);
}
